(function ($) {
	$(document).ready(function () {
		loadCalendarDay();
		$('.tribe-mini-calendar-nav-link').on('click', function (e) {
			loadCalendarDay();
		});

		var event1 = $('.tribe-mini-calendar-event.event--1').first();
		var event2 = event1.next();
		var day1 = $(event1).find('.list-daynumber').text();
		var day2 = $(event2).find('.list-daynumber').text();
		if (day1 && day2) {
			if (day1 === day2) {
				$(event2).find('.list-daynumber').hide();
				$(event2).find('.list-dayname').hide();
				$(event2).find('br').hide();
				$(event2).find('.list-date').css('margin', '0');
			}
		}
		$('.maptip').tooltipster({
			interactive: true,
			theme: ['tooltipster-shadow', 'tooltipster-shadow-customized'],
			distance: 15,
		});
	});
	// Globals
	var queryParam;
	var postsPerPage = 6;

	// Query String Functions
	function updateURL(param) {
		var newurl =
			window.location.protocol +
			'//' +
			window.location.host +
			window.location.pathname +
			'?' +
			param;
		window.history.pushState({ path: newurl }, '', newurl);
		return param;
	}

	function openInNewTab(url) {
		var win = window.open(url, '_blank');
		win.focus();
	}

	$('#print_tooltip_content a').click(function (e) {
		e.preventDefault();
		var path = queryParam === undefined ? '' : queryParam;
		var url =
			window.location.protocol +
			'//' +
			window.location.host +
			'/news-and-events/events-calendar/?' +
			path +
			'&print=' +
			$(this).attr('data-print');
		openInNewTab(url);
	});

	// Calendar ajax
	function changeEventMonth(e, month) {
		//prevent the default ajax behavior from the plugin
		e.stopImmediatePropagation();
		//don't follow the anchor link
		e.preventDefault();
		//get the id so we know what date to give our query

		// Add date to url
		var dateParam = $.param({ month: month });
		updateURL(dateParam);
		// make the ajax call to update our query

		$.ajax({
			url: '/wp-admin/admin-ajax.php',
			type: 'POST',
			data: {
				action: 'calendar_month_events',
				month: month,
			},
			beforeSend: function () {
				if (
					$(
						'.month-view .tribe-events-loop .events-calendar-list .event-ul',
					).html()
				) {
					$(
						'.month-view .tribe-events-loop .events-calendar-list .event-ul',
					).html('');
				}
				$(
					'.month-view .tribe-events-loop .events-calendar-list .event-ul',
				).append(
					'<li class="event-content" id="loader" aria-live="assertive">Loading Events...</li>',
				);
			},
			success: function (res) {
				if (res !== '') {
					$(
						'.month-view .tribe-events-loop .events-calendar-list .event-ul',
					).html('');
					$(
						'.month-view .tribe-events-loop .events-calendar-list .event-ul',
					).append(res);
				} else {
					$(
						'.month-view .tribe-events-loop .events-calendar-list .event-ul',
					).html('');
					$(
						'.month-view .tribe-events-loop .events-calendar-list .event-ul',
					).append(
						'<li class="event-content" id="loader">Sorry. Try another search.</li>',
					);
				}
			},
			error: function (err) {
				console.error(err);
			},
		});
		return dateParam;
	}

	function loadCalendarDay() {
		$(document).on('click', '.tribe-mini-calendar-day-link', function (e) {
			//prevent the default ajax behavior from the plugin
			e.stopImmediatePropagation();
			//don't follow the anchor link
			e.preventDefault();
			//get the id so we know what date to give our query
			$('.tribe-mini-calendar-day-link').removeClass('active-day');
			$(this).addClass('active-day');
			var date = $(this).attr('data-day');

			// Add date to url
			var dateParam = $.param({ date: date });
			queryParam = updateURL(dateParam);

			//make the ajax call to update our query

			$.ajax({
				url: '/wp-admin/admin-ajax.php',
				type: 'POST',
				data: {
					action: 'calendar_day_events',
					date: date,
				},
				beforeSend: function () {
					if (
						$(
							'.month-view .tribe-events-loop .events-calendar-list .event-ul',
						).html()
					) {
						$(
							'.month-view .tribe-events-loop .events-calendar-list .event-ul',
						).html('');
					}
					$(
						'.month-view .tribe-events-loop .events-calendar-list .event-ul',
					).append(
						'<li class="event-content" id="loader" aria-live="assertive">Loading Events...</li>',
					);
				},
				success: function (res) {
					$(
						'.month-view .tribe-events-loop .events-calendar-list .event-ul',
					).html('');
					$(
						'.month-view .tribe-events-loop .events-calendar-list .event-ul',
					).append(res);
				},
				error: function (err) {
					console.error(err);
				},
			});
		});
	}

	$('.month-view .events-search-input').keyup(function (e) {
		var search = $(this).val();
		var searchParam = $.param({ search: search });
		queryParam = updateURL(searchParam);

		// prevent the default ajax behavior from the plugin
		e.stopImmediatePropagation();

		//make the ajax call to update our query
		$.ajax({
			url: '/wp-admin/admin-ajax.php',
			type: 'POST',
			data: {
				action: 'calendar_search_events',
				searchContent: search,
			},
			beforeSend: function () {
				$('#load-more-posts').hide();
				$('.static-initial-count').remove();
				if (
					$(
						'.month-view .tribe-events-loop .events-calendar-list .event-ul',
					).html()
				) {
					$(
						'.month-view .tribe-events-loop .events-calendar-list .event-ul',
					).html('');
				}
				$(
					'.month-view .tribe-events-loop .events-calendar-list .event-ul',
				).append(
					'<li class="event-content" id="loader" aria-live="assertive">Loading Events...</li>',
				);
			},
			success: function (res) {
				if (res !== '') {
					$(
						'.month-view .tribe-events-loop .events-calendar-list .event-ul',
					).html('');
					$(
						'.month-view .tribe-events-loop .events-calendar-list .event-ul',
					).append(res);

					// Get total events count from hidden input
					const totalEvents = parseInt($('#total-events-count').val() || 0);

					// Show/hide load more button based on total count
					if (totalEvents <= 6) {
						$('#load-more-posts').hide();
					} else {
						$('#load-more-posts').show().removeClass('d-none');
					}
				} else {
					$(
						'.month-view .tribe-events-loop .events-calendar-list .event-ul',
					).html('');
					$(
						'.month-view .tribe-events-loop .events-calendar-list .event-ul',
					).append(
						'<li class="event-content" id="loader" aria-live="assertive">Sorry. Try another search.</li>',
					);

					$('#load-more-posts').hide();
				}
			},
			error: function (err) {
				console.error(err);
			},
		});
	});

	$(document).on('click', '.tribe-mini-calendar-nav a', function (e) {
		var date = $(this).attr('data-month');
		queryParam = changeEventMonth(e, date);
	});

	$('#load-more-posts').click(function (e) {
		e.preventDefault();
		$('.static-initial-count').remove();
		postsPerPage += 6;

		var urlParams = new URLSearchParams(window.location.search);
		var currMonth = urlParams.get('month');
		var currSearch = urlParams.get('search');

		$.ajax({
			url: '/wp-admin/admin-ajax.php',
			type: 'POST',
			data: {
				action: 'load_more_posts',
				load_more_posts: {
					amount: postsPerPage,
					month: currMonth,
					search: currSearch,
				},
			},
			success: function (res) {
				$(
					'.month-view .tribe-events-loop .events-calendar-list .event-ul',
				).html('');
				$(
					'.month-view .tribe-events-loop .events-calendar-list .event-ul',
				).append(res);
				// Calculate which page we're on based on postsPerPage
				var currentPage = Math.ceil(postsPerPage / 6);

				// Find first item in the newly loaded group
				var startIndex = (currentPage - 1) * 6;
				var firstNewItem = $('.event-ul .event-li').eq(startIndex);
				// Set focus to first new item if it exists
				if (firstNewItem.length) {
					firstNewItem.find('a').focus();
				}
				let currentEvents = $('.event-ul .event-li').length;
				// Update current count
				$('.current-count').text(currentEvents);
			},
			error: function (err) {
				console.error(err);
			},
		});
	});
})(jQuery);
